// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class GainerLoserData {
    constructor(type) {
        this.Range = null;
        this.Volume = null;
        this.Behavior = type;
    }
}
